module.exports = __webpack_public_path__ + "static/ArchiveVideo07-c4a405498c907ec852416903bd60a79f.mp4";